import { useEffect, useMemo } from "preact/hooks";
import type { FlowState } from "../flow/machine";
import type { InstallRunner } from "../flow/runner";
import { t } from "../i18n";
import { encodeQr, qrToSvg } from "../qr/qr";

const ORDER = ["pending", "token_consumed", "enrolled", "probed", "live"] as const;

export function EnrollStep({ runner, s }: { runner: InstallRunner; s: FlowState }) {
  const e = s.enrollment;
  const enrollmentId = e?.id;
  const qrPayload = e?.qrPayload;
  useEffect(() => {
    const cur = runner.store.state.enrollment;
    if (!cur) void runner.requestEnrollmentToken();
    else if (cur.state !== "expired" && cur.state !== "failed") void runner.pollEnrollment();
  }, [runner, enrollmentId]);
  const svg = useMemo(() => (qrPayload ? qrToSvg(encodeQr(qrPayload), { title: t("enroll.qr_alt") }) : ""), [qrPayload]);
  const cur = e ? ORDER.indexOf(e.state as (typeof ORDER)[number]) : -1;
  return (
    <div class="panel">
      <h2 tabIndex={-1}>{t("enroll.heading")}</h2>
      <p>{t("enroll.intro")}</p>
      {!e ? (
        <button type="button" class="primary" onClick={() => void runner.requestEnrollmentToken()}>{t("enroll.request")}</button>
      ) : (
        <div class="grid2">
          <div>
            <div class="qr" role="img" aria-label={t("enroll.qr_alt")} dangerouslySetInnerHTML={{ __html: svg }} />
          </div>
          <div>
            <p class="muted">{t("enroll.token_label")}</p>
            <p class="token" aria-label={t("enroll.token_label")}>{e.token}</p>
            <p class="hint">{t("enroll.expires", { when: new Date(e.expiresAt).toLocaleTimeString() })}</p>
            <ol class="timeline" aria-live="polite">
              {ORDER.map((st, i) => (
                <li key={st} class={i < cur ? "done" : i === cur ? "current" : ""}>{t(`enroll.state.${st}`)}</li>
              ))}
            </ol>
            {(e.state === "expired" || e.state === "failed") && (
              <button type="button" class="primary" onClick={() => { runner.retry(); void runner.requestEnrollmentToken(); }}>{t("enroll.request")}</button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
